export default {
    data() {
        return {
            donationType: '',

            visibleTotals: {
                payOnline: [
                    'pay_online',
                    'pay_online_without_extras',
                    'insurance_online',
                    'extras_online',
                    'insurance_on_arrival',
                    'extras_on_arrival',
                    'green_heart_donation',
                    'total',
                ],
                payOnArrival: [
                    'pay_online',
                    'pay_online_without_extras',
                    'insurance_online',
                    'extras_online',
                    'green_heart_donation',
                    'pay_on_arrival',
                    'pay_on_arrival_without_extras',
                    'insurance_on_arrival',
                    'extras_on_arrival',
                    'total',
                ],
            },
        };
    },

    computed: Object.assign({
        sortedTotals() {
            const ordered = {};
            const paymentType = this.prePaid ? 'payOnline' : 'payOnArrival';

            Object.keys(this.totals)
                .sort((a, b) => {
                    return this.visibleTotals[paymentType].indexOf(a) - this.visibleTotals[paymentType].indexOf(b);
                })
                .forEach(key => {
                    ordered[key] = this.totals[key];
                });

            return ordered;
        },
        prePaid() {
            return this.quote.payment_type === 'PP';
        },
        priceIsConverted() {
            return this.quote.currency !== this.selectedCurrency.code;
        },
    }),

    methods: {
        displayTotal(key) {
            return (
                this.visibleTotals[this.prePaid ? 'payOnline' : 'payOnArrival'].includes(key) && this.totals[key] > 0
            );
        },
        isSubItem(key) {
            if (this.prePaid) {
                return ['insurance_online', 'extras_online', 'pay_online_without_extras'].indexOf(key) > -1;
            }

            return (
                [
                    'insurance_online',
                    'extras_online',
                    'pay_online_without_extras',
                    'insurance_on_arrival',
                    'extras_on_arrival',
                    'pay_on_arrival_without_extras',
                ].indexOf(key) > -1
            );
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/mixins/TotalCosts.js